import { Button, Flex, Text } from '@servicetitan/anvil2';
import Launch from '@servicetitan/anvil2/assets/icons/material/round/launch.svg';
import documentError from './document-error.svg';

interface PrequalDeclinedScreenProps {
    onApplyNow: () => void;
}

export const PrequalDeclinedScreen = ({ onApplyNow }: PrequalDeclinedScreenProps) => {
    return (
        <Flex direction="column" gap="12" style={{ padding: '16px 0' }}>
            <Flex direction="column" gap="6" alignItems="center" style={{ textAlign: 'center' }}>
                {/* Document icon with warning indicator */}
                <img
                    src={documentError}
                    alt="Pre-qualification declined"
                    style={{ marginTop: '16px' }}
                />

                {/* Title */}
                <Text variant="headline" el="h2">
                    We currently have no prequalified offers for you.
                </Text>

                {/* Explanation message */}
                <Text variant="body" size="medium">
                    We are sorry but we are not able to provide you with a prequalified offer at
                    this time.
                    <br />
                    However, you may still apply for financing.
                </Text>
            </Flex>
            <Flex direction="column" gap="2" alignItems="flex-start">
                {/* Credit report information */}
                <Text variant="body" size="small" color="subdued">
                    If you currently have a lock or freeze on your credit report, you will need to
                    remove/unlock the report prior to applying.
                </Text>
            </Flex>
            {/* Apply Now button */}
            <Button
                appearance="primary"
                onClick={onApplyNow}
                icon={Launch}
                style={{ marginTop: 'auto', width: '100%' }}
            >
                Apply Now
            </Button>
        </Flex>
    );
};
